import loading from '../Assets/loading.gif';
import {  getState, handleSubmit } from "./function";
import React from "react";

function Button(props) {
  let ClassXD = props.buttonClass;
  if(props.disabled && props.disabled?.length > 0){
    ClassXD = props.buttonClass+" disabled";
  }

    return (
      <>
  
  <div className={props.wrapperClass}>
      {getState(props.self, 'loading') !== '1' ?
      (<button className={ClassXD} disabled={props.disabled}
           onClick={() => handleSubmit(props.self, props.buttonAction) }>
               {props.buttonText}
                </button>) :  (<button className={props.buttonClass +" disabled loading"}>
             <img height="40px" src={loading} alt="Loading..."/>
             </button>)
       }
        </div>
      </>
    );
}

export default Button;